import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text/text.component';
import { ActionPressedChip } from '../atoms/action-pressed-chip';
import { flexCenter } from '../common-styles';

type ImageActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const ImageAction = ({ compact = true, showBoxShadow = true, ...rest }: ImageActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='em' weight='bold' className={flexCenter}>
        <Icon name='image-small' />
      </Text>
    </ActionPressedChip>
  );
};
